import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ListResponse } from "../interfaces/list-response.interface";
import { Post, PostCategory } from "../interfaces/post.interface";
import { Tags } from "../models/tags.model";
import { AuthenticationService } from "./auth.service";

@Injectable({
  providedIn: "root"
})
export class ApiServiceNewsFeed {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) { }

  private optionsHeader = {
    headers: new HttpHeaders({
      "Content-Type": "application/json; charset=UTF-8",
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25",
      Authorization: this.authenticationService.getBearerToken()
    })
  };

  private optionsHeaderFile = {
    headers: new HttpHeaders({
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25",
      Authorization: this.authenticationService.getBearerToken()
    })
  };

  getPost(uuid: string) {
    return this.http.get<Post>(`/blog/posts/${uuid}`, this.optionsHeader);
  }

  getAllPosts(status: string, order = "ASC", total_page = "999999") {
    return this.http.get<ListResponse<Post[]>>("/blog/posts", {
      ...this.optionsHeader,
      params: { status, total_page, order }
    });
  }

  createPost(data: FormData) {
    return this.http.post<void>("/blog/posts", data, this.optionsHeaderFile);
  }

  updatePost(uuid: string, data: FormData) {
    return this.http.put<Post>(`/blog/posts/${uuid}/edit`, data, this.optionsHeaderFile);
  }

  archivedPost(uuid: string) {
    return this.http.patch<void>(`/blog/posts/${uuid}/status?status=ARCHIVED`, {}, this.optionsHeader);
  }

  getAllCategory(status: string) {
    return this.http.get<any>("/blog/categories", { ...this.optionsHeader, params: { status } });
  }

  createCategory(name: string) {
    return this.http.post<PostCategory>("/blog/categories", { name }, this.optionsHeader);
  }

  archivedCategory(uuid: string) {
    return this.http.patch<void>(`/blog/categories/${uuid}/status?status=ARCHIVED`, {}, this.optionsHeader);
  }

  getAllTags(status: string) {
    return this.http.get<any>("/blog/tags", { ...this.optionsHeader, params: { status } });
  }

  archivedTag(uuid: string) {
    return this.http.patch<void>(`/blog/tags/${uuid}/status?status=ARCHIVED`, {}, this.optionsHeader);
  }

  createTag(name: string) {
    return this.http.post<Tags>("/blog/tags", { name }, this.optionsHeader);
  }

  uploadImage(formData: FormData) {
    return this.http.post<{ href: string }>(`/blog/posts/images`, formData, this.optionsHeaderFile);
  }
}
